import * as React from 'react';
import { withStyles } from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import { RouteAuditSummary } from '../IRouteAudit';

const styles: any = (theme: any) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start'
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '0 30px',
    borderRight: `1px solid ${theme.AppBGColor}`,
    '&:first-child': {
      paddingLeft: 0
    },
    '&:last-child': {
      borderRight: 'none'
    }
  },
  sectionTitle: {
    color: theme.gridTextColor,
    fontSize: theme.textFontSize,
    fontWeight: 600,
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  dataContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: '30px'
  },
  dataItem: {
    color: theme.TextColor,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    minWidth: 100
  },
  dataValue: {
    fontSize: theme.headerTextFontSize24,
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  dataLabel: {
    fontSize: theme.textFontSize16,
    fontWeight: 400
  },
  highlightedDataValue: {
    color: theme.palette.primary.main
  },
  starIcon: {
    color: theme.gridTextColor,
    fontSize: theme.headerTextFontSize24
  }
});

interface SummaryProps {
  classes: any;
  data: RouteAuditSummary;
}

const Summary = ({ classes, data }: SummaryProps) => {
  const {
    totalAudits,
    totalShipmentsWithIssues,
    totalDamagedShipments,
    totalShortageShipments,
    totalOutOfSequenceShipments,
    totalRecouped,
    averageQualityRating
  } = data;
  const summarySchema = [
    {
      title: 'Driver Audits',
      data: [
        {
          title: 'Total',
          value: totalAudits,
          class: classes.highlightedDataValue
        }
      ]
    },
    {
      title: 'Bills With Issues',
      data: [
        {
          title: 'Total',
          value: totalShipmentsWithIssues
        },
        {
          title: 'Shortage',
          value: totalShortageShipments
        },
        {
          title: 'Damages',
          value: totalDamagedShipments
        },
        {
          title: 'Out of Sequence',
          value: totalOutOfSequenceShipments
        }
      ]
    },
    {
      title: 'Trailer Performance',
      data: [
        {
          title: 'Recouped',
          value: totalRecouped
        },
        {
          title: 'Avg Rating',
          value: averageQualityRating,
          icon: <StarIcon className={classes.starIcon} />
        }
      ]
    }
  ];

  const renderDataItem = (item: any, index: number) => {
    return (
      <div key={index} className={`${classes.dataItem} ${item.class ?? ''}`}>
        <div className={classes.dataValue}>
          <span>{item.value}</span>
          <span>{item.icon ?? null}</span>
        </div>
        <div className={classes.dataLabel}>{item.title}</div>
      </div>
    );
  };

  return (
    <div className={classes.root}>
      {summarySchema.map((section, sectionIndex) => (
        <div key={sectionIndex} className={classes.section}>
          <div className={classes.sectionTitle}>{section.title}</div>
          <div className={classes.dataContainer}>
            {section.data.map((dataItem, dataIndex) => renderDataItem(dataItem, dataIndex))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default withStyles(styles)(Summary);
